// GameContext.js
import { TOKEN_KEY } from 'api';
import { getAll, getMe } from 'api/games';
import { createContext, useContext, useEffect, useState } from 'react';

const GameContext = createContext();

export const GameProvider = ({ children }) => {
  const [state, setState] = useState({
    isLoading: false,
    games: [],
  });

  const getAllGames = async () => {
    setState((prev) => ({ ...prev, isLoading: true }));
    try {
      const { data } = await getAll();

      setState((prevState) => ({
        ...prevState,
        isLoading: false,
        games: data.games,
      }));
    } catch (err) {
      console.error(err);
    } finally {
      setState((st) => ({
        ...st,
        isLoading: false,
      }));
    }
  };

  const addGame = (game) => {
    setState((st) => ({
      ...st,
      games: [game, ...st.games],
    }));
  };

  const deleteGame = (id) => {
    setState((st) => ({
      ...st,
      games: st.games.filter((game) => game.id !== id),
    }));
  };

  const updateGame = (updatedGame) => {
    setState((st) => ({
      ...st,
      games: st.games.map((game) => (game.id === updatedGame.id ? updatedGame : game)),
    }));
  };

  useEffect(() => {
    getAllGames();
  }, []);

  return (
    <GameContext.Provider
      displayName='Game Context'
      value={{
        isLoading: state.isLoading,
        games: state.games,
        deleteGame,
        addGame,
        getAllGames,
        updateGame,
      }}
    >
      {children}
    </GameContext.Provider>
  );
};

export const useGames = () => useContext(GameContext);
